import { Auth, Connect, Message } from '@genesislcap/foundation-comms';
import { DI } from '@microsoft/fast-foundation';

export interface ICommonService {
  getAllCountries(): Promise<Message>;
  getAllStates(): Promise<Message>;
  isItIsBuyingHours(): Promise<Message>;
  getCounties(criteria: string): Promise<Message>;
  getCities(criteria: string): Promise<Message>;
  getHubZoneMatrix(): Promise<Message>;
  getResuretyInterPoints(): Promise<Message>;
  getAllIso(): Promise<Message>;
  getTradeSessionTime(): Promise<Message>;
}

class CommonServiceImpl implements ICommonService {
  constructor(@Connect private connect: Connect, @Auth private auth: Auth) {}

  public getAllCountries(): Promise<Message<any>> {
    const request = this.connect.request('COUNTRIES');
    return request;
  }

  public getAllStates(): Promise<Message<any>> {
    const request = this.connect.request('STATES');
    return request;
  }

  public async isItIsBuyingHours(): Promise<Message<any>> {
    return this.connect.request('IS_BUSINESS_HOUR', {
      REQUEST: true,
    })
  }

  public getCounties(stateName: string): Promise<Message<any>> {
    const params = {
      REQUEST: {
        STATE_NAME: stateName,
      },
    };
    const request = this.connect.request('COUNTIES', params);
    return request;
  }

  public getCities(stateName: string): Promise<Message<any>> {
    const params = {
      REQUEST: {
        STATE_NAME: stateName,
      },
    };
    const request = this.connect.request('CITIES', params);
    return request;
  }

  public getHubZoneMatrix(): Promise<Message<any>> {
    const request = this.connect.request('HUB_ZONE_MATRIX');
    return request;
  }

  public getResuretyInterPoints(): Promise<Message<any>> {
    const params = {
      DETAILS: {
        MAX_ROWS: 100000,
      },
    };
    const request = this.connect.request('RESURETY_REMODEL_INTERCONNECTION_POINT', params);
    return request;
  }

  public getAllIso(): Promise<Message<any>> {
    const request = this.connect.request('ISO', { REQUEST: true });
    return request;
  }

  public getTradeSessionTime(): Promise<Message> {
    return this.connect.request('REQ_TRADE_SESSION_TIME', { REQUEST: {} });
  }
}

export const ICommonService = DI.createInterface<ICommonService>((x) =>
  x.singleton(CommonServiceImpl)
);
